module.exports = __webpack_public_path__ + "static/media/Leccion-Marzo-5-El-Discipulo-y-su-Compromiso-Maestro.77942398.pdf";